export default __webpack_public_path__ + "static/media/Icons-Outline-Globe-White.b0b6ecb7.svg";